module.exports = __webpack_public_path__ + "static/media/browse.6b16f07f.svg";